module.exports = __webpack_public_path__ + "img/9.10a01e3e.jpg";